import { Chevron } from "@faire/web/slate/icons/foundation/Chevron";
import { HorizontalLine } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import * as React from "react";
import styled from "styled-components";

interface IProps {
  initiallyExpanded?: boolean;
  maximumHeight?: number;
  children?: React.ReactNode;
}

const MAX_COLLAPSED_HEIGHT = 360;

export const ExpandableToFullHeight: React.FC<IProps> = ({
  initiallyExpanded = false,
  maximumHeight = MAX_COLLAPSED_HEIGHT,
  children,
}) => {
  const [isExpanded, setIsExpanded] = React.useState(initiallyExpanded);
  const [showButton, setIsShowButton] = React.useState(false);
  const wrapperRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const showButton = !!(
      wrapperRef.current && wrapperRef.current.scrollHeight > maximumHeight
    );
    setIsShowButton(showButton);
    if (!showButton) {
      setIsExpanded(true);
    }
  }, [maximumHeight, wrapperRef.current?.scrollHeight]);

  const handleClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <Wrapper
        ref={wrapperRef}
        style={{
          maxHeight: isExpanded ? "unset" : `${maximumHeight}px`,
          overflowY: isExpanded ? "visible" : "auto",
        }}
      >
        {children}
      </Wrapper>
      <HorizontalLine />
      {showButton ? (
        <ButtonWrapper role="button" onClick={handleClick}>
          <StyledChevron direction={isExpanded ? "up" : "down"} />
        </ButtonWrapper>
      ) : (
        <Spacer height="1x" />
      )}
    </>
  );
};

const Wrapper = styled.div`
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  padding: ${getSpacing("1x")};
  cursor: pointer;
`;

const StyledChevron = styled(Chevron)`
  margin: auto;
`;
